// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__1bKeQ","box":"WorkspacesBox_box__2VJ43","node":"WorkspacesBox_node__2sFSo"};